exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#faq_page > .container[data-v-14e5172d] {\n  max-width: 600px;\n}\n.category-name[data-v-14e5172d] {\n  color: #77c5ff;\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 7px;\n  margin-bottom: 10px;\n  display: block;\n}\n.category-name[data-v-14e5172d]:not(:first-of-type) {\n    margin-top: 25px;\n}\n.question-container[data-v-14e5172d] {\n  width: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  min-height: 60px;\n  border-radius: 5px;\n  margin-bottom: 5px;\n}\n", ""]);

// exports
